import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Col, Row, Form } from "react-bootstrap";
import TableForm from "../../../../components/TableForm";
import ConfirmModal from "../../../../components/ConfirmModal";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { PreviewIcon } from "../../../../data/iconImage";
import InputSearch from "../../../../components/InputSearhComponent";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import { getQueryString } from "../../../../utils/Query";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import PropTypes from "prop-types";
import BillOfReqDtService from "../../../../services/billofreqdt.service";
import TableForm2s from "../../../../components/TableFormScrb";
import TechnicianInspRevService from "../../../../services/techinsprev.service ";
import moment from "moment";
import { toFormatISO } from "../../../../utils/Time";

export default function CheckEquipment({ defaultData }) {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const defaultDatas = [
    {
      rowIndex: 0,
      sup_team: "",
      jobtype_name: "",
      Service_req_no: "",
      Cus_code: "",
      Cus_name: "",
      Item_name: "",
      job_start_date: "",
      job_finish_date: "",
      job_actual_date: "",
      tech_mas_name: "",
      technician_work_status: "",
      seq_st_name: "",
      seq_st_job: "",
      reject_reson: ""
    }
  ];

  const [dataModal, setDataModal] = useState({ Array: [] });
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const [allWorkNo, setAllWorkNo] = useState()
  const [querySearch, setQuerySearch] = useState()

  useEffect(() => {
    setJobType(defaultData.job_type)
    fetchSeqNo()
  }, [defaultData]);

  const columns = [
    {
      name: "RequestNumber",
      label: "เลขที่ใบขอเบิก",
      type: "text",
      readOnly: true
    },
    {
      name: "EquipmentCode",
      label: "รหัสอุปกรณ์/อะไหล่",
      readOnly: true,
      width: "200px"
    },
    {
      name: "EquipmentName",
      label: "ชื่ออุปกรณ์/อะไหล่",
      readOnly: true,
      width: "200px"
    },
    {
      name: "ModelNumber",
      label: "Model Number",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Barcode",
      label: "บาร์โคด",
      readOnly: true,
      className: "barcode-field",
      type: "barcode",
      width: "180px"
    },
    {
      name: "Warehouse",
      label: "คลัง",
      readOnly: true
    },
    {
      name: "RequireQuantity",
      label: "เบิก",
      readOnly: true,
    },
    {
      name: "ReceivedQuantity",
      label: "จำนวนรับ",
      readOnly: true
    },
    {
      name: "Unit",
      label: "หน่วย",
      readOnly: true
    },
    {
      name: "Use",
      label: "Use",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Status"],
      options: initializeSetOption({
        key: "Status",
        label: "Status",
        dataset: [
          { Status: "Y", Use: true },
          { Status: "N", Use: false }
        ]
      })
    },
    {
      label: "",
      type: "activeButton"
    }
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "จากวันที่รับงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4
    },
    {
      name: "end",
      label: "ถึงวันที่รับงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: "start"
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      noneAsync: true,
      // queryService: (query, value) => {
      //   const q = getQueryString({ seq_no: value, plan_status: "NOT-OPEN", limit: 100, page: 1 })
      //   getServiceRequest({
      //     showAlert,
      //     setLoading: () => { },
      //     serviceRequest: TechnicianReceiveService.getSeqNo(q),
      //     callback: (array) => {
      //       const newArray = array.map(arr => ({
      //         seq_no: arr.seqJob.seqNo
      //       }))
      //       setWorkNo(newArray)
      //     }
      //   });
      // }
    },
  ];
  const handleSubmitTeams = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback.Array?.length) {
      try {
        console.log('dataCallback', dataCallback);
        await handleSubmitPlanDts(dataCallback);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const handleSubmit = async (e, { dataCallback, showCallback }) => {
    e.preventDefault();
    setShowModal(showCallback);

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianInspRevService.createTechnicianInspRev(dataCallback),
      navigated: (navi) =>
        navi &&
        navigate("/service_work/acceptance", {
          state: "acceptance"
        })
    });
    setTableData([])
  };

  const handleSubmitDelete = (event, dataCallback) => {
    event.preventDefault();

    if (dataCallback) {
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: BillOfReqDtService.deleteBillOfReqDts(dataCallback.Id, false),
        navigated: (navi) => navi && navigate("/service_work/acceptance", {
          state: { name: "CheckEquipment" }
        })
      });
      getDataTable();
    }
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  function initData(data) {
    const newArray = data?.map((items) => ({
      Id: items.Id,
      RequestNumber: items.BillOfReqHd.Bill_Doc_No,
      EquipmentCode: items.Item.Item_Code,
      EquipmentName: items.Item.Item_Name_TH || items.Item.Item_Name_EN,
      ModelNumber: items.Item.Item_Model,
      Barcode: items.Item.Item_PartNo,
      Warehouse: items.Wh_Code,
      RequireQuantity: items.Req_Qty,
      ReceivedQuantity: items.Iss_Qty,
      Unit: items.Item.Unit, //items.unit_uom,
      Use: items.Use_Status,
      Bill_Of_Hd_Id: items.Bill_Of_Hd_Id,
      Tech_Plan_Id: items.BillOfReqHd.SeqOthersJob?.TechnicianPlan?.id ||
        items.BillOfReqHd.Seqinstalljob?.TechnicianPlan?.id,

      Tech_Insp_Rev_Date: items.BillOfReqHd.SeqOthersJob?.TechnicianPlan?.TechnicianReceive[0].tech_rev_date
    }));
    // setData({ Array: newArray });
    setTableData(newArray || [])
    setLoading(false)
  }

  const getDataTable = (search) => {
    if (!search?.seq_no) {
      setTableData([])
      return
    }
    setLoading(true)
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = {
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search.start),
      end: toFormatISO(search?.end)
    }
    setQuerySearch(q)
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechnicianReceiveService.getEquipment(getQueryString(q)),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });

  }

  function fetchSeqNo(search) {
    if (!search) {
      if (!allWorkNo) {
        getSeqNoList({}, 'all')
      } else {
        setWorkNo(allWorkNo)
      }
      return
    }

    getSeqNoList(search)
  }
  function getSeqNoList(search, isAll) {
    const q = getQueryString(search)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechnicianReceiveService.getSeqNoPartEquip(q),
      callback: (res) => {
        const data = res.map(d => {
          return { seq_no: d.seqJob?.seqNo }
        })
        if (isAll) {
          setAllWorkNo(data)
        }
        setWorkNo(data)
      }
    });
  }
  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          {/* <SearchFilter
            data={data.Array}
            inputField={searchInput}
            fieldClassName={{ actionButton: "w-auto py-2", inputRow: "justify-content-end align-items-center" }}
            showActionButtons={false}
            searchCallback={(searchCallback) => {
              const vfilteredData = searchCallback.filter((obj) =>
                obj.hasOwnProperty("value")
              );
              handleSearchFilter(vfilteredData);
              setSearchValue({ Array: [searchCallback] })
            }}
          /> */}
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchByField={{ name: 'seq_no', queryService: search => fetchSeqNo(search) }}
            searchCallback={search => { search ? getDataTable(search) : setTableData([]); setQuerySearch() }}
            fieldClassName={{ actionButton: "", inputRow: "justify-content-end" }}
          />
        </Card.Body>
      </Card>

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดอุปกรณ์/อะไหล่
            </Card.Title>
            <div className="ms-auto">
              {/* <Button
                  //type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                  //onClick={() => setShowModal(!showModal)}
                >
                  แสดงใบขอเบิก
                </Button> */}
              {/* <Button
                //type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
              //onClick={() => setShowModal(!showModal)}
              >
                แสดงใบรับอุปกรณ์/อะไหล่
              </Button> */}
              <Button
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() =>
                  navigate("equipment")
                }
              >
                สรุปรายการรับอุปกรณ์/อะไหล่
              </Button>
            </div>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData}
              columns={columns}
              defaultData={defaultDatas[0]}
              checkBoxShow={false}
              pending={loading}
              editForm={false}
              // activeButton={["view", "delete"]}
              previewButton={{
                link: "equipment/preview",
                state: "CheckEquipment"
              }}
              isLoading={loading}
              deleteButton
              onDeleteCallback={handleSubmitDelete}
              onChangeCallback={(newData) => {
                const array = newData.filter(d => d.isEdit)
                  .map((item) => ({
                    bill_of_hd_id: item.Bill_Of_Hd_Id,
                    bill_of_dt_update: [{
                      Id: item.Id,
                      Use_Status: item.Use
                    }],
                    tech_plan_id: item.Tech_Plan_Id,
                    tech_insp_rev_date: item.Tech_Insp_Rev_Date
                  }));
                setTableData(newData);
                setDataModal({ Array: array });
              }}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              rowCount={allCountData}
            />
          </Card.Body>

          <Row className="mt-3 justify-content-end">
            <Col className="col-auto">
              <Button
                type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => setShowModal(!showModal)}
                hidden={!tableData.length}
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                data={dataModal}
                content={"add"}
                onSubmitCallback={handleSubmit}
              />
            </Col>
          </Row>
        </Card>
      </Form>
    </>
  );
}

CheckEquipment.propTypes = {
  defaultData: PropTypes.object,
};